import React from "react";
import { Modal } from "../ui";

interface ImagePreviewModalProps {
  show: boolean;
  onClose: () => void;
  imageSrc: string;
  title?: string;
}

const ImagePreviewModal: React.FC<ImagePreviewModalProps> = ({
  show,
  onClose,
  imageSrc,
  title = "Image Preview",
}) => (
  <Modal
    open={show}
    onOpenChange={(open) => !open && onClose()}
    title={title}
    className="max-w-3xl"
  >
    <img
      src={imageSrc}
      alt={title}
      className="mx-auto max-h-[70vh] max-w-full object-contain"
    />
  </Modal>
);

export default ImagePreviewModal;
